import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Customize the look and feel of the portal for a specific partner. Changes affect how the portal appears to users under that partner's organization." id="customize_the_look_and_feel_of_the_porta.d142a23d" />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Branding Overview" id="branding_overview.c7cce7ca" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Configure <strong>colors</strong>, <strong>logos</strong>, and <strong>styling options</strong> to match the partner's brand identity." id="configure_colors_logos_and_styling_optio.cf355f27" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Theme Settings" id="theme_settings.2cd09a06" />
        }
    ],
    title: <FormattedMessage defaultMessage="Site Branding" id="site_branding.7eede7ca" />
};
